import { CDC_APIKEY, CDC_APIKEY_IDP } from "../constants/api-constants"
import axios from "axios"

export const GetLogedToken = async (uid) => {
  try {
    const resToken = await axios.get(
      `${process.env.CATEGORY_API_URL}/comfama/tokenizer/api/v1/accessToken?uid=${uid}`,
    )
    if (resToken.status === 200) {
      return resToken.data.data.accessToken
    }
  } catch (error) {
    console.log(error)
  }
}

export const GetUnlogedToken = async () => {
  const config = {
    headers: {
      apikey: CDC_APIKEY,
    },
  }

  const data = {
    action: "getJWT",
  }

  const url = process.env.URL_CDC
  try {
    const dataResponse = await axios.post(`${url}`, data, config)
    if (dataResponse.data.data.statusCode === 200) {
      const dataUser = {
        documentNumber: 99999999,
        documentType: "C01C",
      }
      const url = process.env.URL_CDC_IDP_UNLOGIN
      const config = {
        headers: {
          apikey: CDC_APIKEY_IDP,
          authorization: `Bearer ${dataResponse.data.data.id_token}`,
        },
      }

      const resToken = await axios.post(`${url}`, dataUser, config)
      if (resToken.data.status === 200) {
        return resToken.data.data
      }
    }
  } catch (error) {
    console.log(error)
  }
}
